import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LocationRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("location");
